import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { ShieldCheck, Factory, Building2, Cctv, Siren, ArrowRight } from "lucide-react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import Seo from "@/components/Seo";

const ICONS = { "Security Guards": ShieldCheck, "Industrial Security": Factory, "Commercial Security": Building2, "Technology Security": Cctv, "Special Services": Siren };
const IMAGES = {
  "Security Guards": "https://images.pexels.com/photos/27299956/pexels-photo-27299956.jpeg",
  "Technology Security": "https://images.pexels.com/photos/430208/pexels-photo-430208.jpeg",
  "Industrial Security": "https://images.pexels.com/photos/290275/pexels-photo-290275.jpeg",
};

export default function Services() {
  const [cats, setCats] = useState([]);
  useEffect(() => { api.get("/services").then((r) => setCats(r.data)).catch(() => {}); }, []);
  return (
    <div>
      <Seo
        title="Security Services — Guards, CCTV, Industrial & Commercial | GuardDekho.com"
        description="Explore every security service on GuardDekho.com — manned guarding, industrial and commercial security, CCTV, access control and special services from verified agencies across India."
      />
      <section className="bg-navy-900 text-white">
        <div className="max-w-7xl mx-auto px-6 py-16">
          <span className="brand-label text-brand">Security Services</span>
          <h1 className="mt-3 font-heading text-4xl sm:text-5xl font-extrabold tracking-tighter">Professional security, every category covered</h1>
          <p className="mt-4 text-navy-300 max-w-2xl text-lg">From manned guarding to CCTV and access control — hire verified providers for any requirement.</p>
        </div>
      </section>
      <section className="max-w-7xl mx-auto px-6 py-16 space-y-14">
        {cats.map((c) => {
          const Icon = ICONS[c.group] || ShieldCheck;
          return (
            <div key={c.group} className="grid lg:grid-cols-3 gap-8 items-start">
              <div className="lg:col-span-1">
                <div className="w-12 h-12 rounded-xl bg-navy-900 text-white flex items-center justify-center"><Icon size={22} /></div>
                <h2 className="mt-4 font-heading text-2xl font-bold text-navy-900 tracking-tight">{c.group}</h2>
                {IMAGES[c.group] && <img src={IMAGES[c.group]} alt={c.group} className="mt-4 rounded-xl h-40 w-full object-cover border border-navy-200" />}
              </div>
              <div className="lg:col-span-2 grid sm:grid-cols-2 gap-3">
                {c.services.map((s) => (
                  <Link to={`/agencies?category=${encodeURIComponent(s)}`} key={s}
                    className="card-lift bg-white border border-navy-200 rounded-lg p-4 flex items-center justify-between group" data-testid={`service-${s.replace(/\s/g, "-").toLowerCase()}`}>
                    <span className="font-medium text-navy-800">{s}</span>
                    <ArrowRight size={16} className="text-navy-300 group-hover:text-brand transition-colors" />
                  </Link>
                ))}
              </div>
            </div>
          );
        })}
      </section>
      <section className="max-w-7xl mx-auto px-6 pb-20">
        <div className="rounded-2xl bg-navy-900 p-10 text-center">
          <h2 className="font-heading text-3xl font-bold text-white">Not sure what you need?</h2>
          <p className="mt-2 text-navy-300">Post your requirement and let verified agencies recommend the right solution.</p>
          <Link to="/post-requirement"><Button className="mt-6 bg-brand hover:bg-brand-600 h-12 px-8">Get Free Quotations</Button></Link>
        </div>
      </section>
    </div>
  );
}
